import { ca } from '@cian/analytics';

export function trackCommunicationTypeShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'communication_type',
    action: 'show',
    label: 'communication_type_toggle',
  });
}

export function trackCommunicationTypeToggle(checked: boolean) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'communication_type',
    action: 'click',
    label: `communication_type_experiment_toggle_${checked ? 'on' : 'off'}`,
  });
}
